/**
 * Dashboard Chart Configuration
 *
 * Shared constants and color palette for dashboard charts
 */

import type { DashboardFilters } from '../types/analytics';

/**
 * Chart color palette (consistent across all charts)
 */
export const CHART_COLORS = {
  orange: '#ea580c',
  blue: '#2563eb',
  green: '#16a34a',
  red: '#dc2626',
  amber: '#d97706',
  purple: '#7c3aed',
  teal: '#0d9488',
  slate: '#475569',
} as const;

/**
 * Pie chart colors
 */
export const PIE_COLORS = [
  CHART_COLORS.blue,
  CHART_COLORS.amber,
  CHART_COLORS.green,
  CHART_COLORS.red,
  CHART_COLORS.purple,
  CHART_COLORS.teal,
  CHART_COLORS.slate,
] as const;

/**
 * Default filter values
 */
export const DEFAULT_FILTERS: DashboardFilters = {
  dateRange: 'last6m',
  jobType: 'all',
  assignee: 'all',
  priority: 'all',
};

/**
 * Date range labels for display
 */
export const DATE_RANGE_LABELS: Record<string, string> = {
  last30: 'Last 30 days',
  last90: 'Last 90 days',
  last6m: 'Last 6 months',
  ytd: 'Year to date',
  all: 'All time',
};
